<template>
  <div class="appeal-point-sp-margin-top">
    <p class="hd-type-04">
      <span>アピールポイント</span>
      <a
        target="_blank"
        class="-right"
        :style="`background: url(${userOfferImageUrlForSp}/icon_arrow_right_red.png) no-repeat left 1px; background-size: 8px 8px;`"
        data-test="help"
        @click="openHelpPopUp('icon.html')"
      >
        アイコンの説明
      </a>
    </p>
    <ul class="appeal-point">
      <li
        v-for="prIcon in prIconsMaster"
        :id="targetIdMap.mainArticle.pr[prIcon.id]"
        :key="prIcon.id"
        :class="{'on':isSetPr(prIcon.id)}"
        :data-test="`pr-${prIcon.id}`"
        v-text="prIcon.name"
      />
    </ul>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/offer/base" as *;
</style>

<script>
import { mapGetters, mapActions } from 'vuex'
import jobPreviewCommon from '@/lib/jobPreviewCommon'

export default {
  mixins: [jobPreviewCommon],
  props: {
    prCodes: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters([
      'prIconsMaster'
    ])
  },
  created () {
    this.storeMaster('prIcons')
  },
  methods: {
    ...mapActions([
      'storeMaster'
    ])
  }
}
</script>
